/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { CardElement } from '@stripe/react-stripe-js';
import React from 'react';
import PropTypes from 'prop-types';
import { Dimmer, Input, Loader, Modal, Transition } from 'semantic-ui-react';
import { ControlPropType } from '../../ctrl_proptype';
import {
  CardElementWrapper,
  Field,
  Fields,
  FormLeft,
  FormRight,
  MerchantImage,
  ModalHeaderContent,
  PaymentForm,
  PaymentFormWrapper,
  PaymentInfo,
  SubmitButton,
} from './stripe.styled';
import { getCountriesList } from '../../../../shared/utils';
import { actionTypes } from './stripe-reducer';

const imgSrc = 'https://storage.googleapis.com/fplsblog/stripe_pay_default.png';
// const imgSrc = 'https://stripe.com/img/documentation/checkout/marketplace.png';

const StripeCheckoutForm = ({
  ctrl,
  formDesign,
  lineItem,
  // eslint-disable-next-line react/prop-types
  stripe,
  isPaying,
  isError,
  // eslint-disable-next-line react/prop-types
  elements,
  finalAmount,
  formData,
  updateState,
  showCheckoutForm,
  disableInputs,
  selectedSubscriptionProductDetails,
  handleInputChange,
  handleFormSubmit,
  storeCardInfo,
  handleCheckSaveCard,
  handleCardElement,
}) => {
  // Stripe card options
  const options = {
    style: {
      base: {
        fontSize: '16px',
        color: '#424770',
        letterSpacing: '0.025em',
        fontFamily: 'Source Code Pro, monospace',
        ':-webkit-autofill': {
          color: '#fce883',
        },
        '::placeholder': {
          color: '#aab7c4',
        },
      },
      invalid: {
        color: '#9e2146',
      },
    },
    hidePostalCode: true,
  };

  const { OTHERS } = actionTypes;

  const renderButtonText = () => {
    const amount = `${ctrl.props.currency} ${finalAmount / ctrl.props.sub_unit}`;
    if (isPaying) {
      return `Paying - ${amount}`;
    }
    return (`${ctrl.props.modal_pay_button} - ` || 'Pay - ') + amount;
  };

  return (
    <>
      <Transition visible={showCheckoutForm} animation="scale" duration={500}>
        <Modal
          closeIcon={!isPaying}
          closeOnDimmerClick={false}
          onClose={() => updateState(OTHERS, { showCheckoutForm: false })}
          onOpen={() => updateState(OTHERS, { showCheckoutForm: true })}
          open={showCheckoutForm}>
          <Modal.Header>
            <ModalHeaderContent
              style={{
                '--fontFamily': formDesign.old.form_font,
              }}>
              <span>{ctrl.props.popup_title}</span>
              <span style={{ marginRight: '10px' }}>
                <img src="/static/images/form/stripe.png" alt="Stripe trusted" height={35} />
              </span>
            </ModalHeaderContent>
          </Modal.Header>
          <Modal.Content content scrolling style={{ margin: 0, padding: 0 }}>
            <PaymentFormWrapper
              className={`stripe-${ctrl.internal_id}`}
              id="payment-form"
              style={{
                '--fontFamily': formDesign.old.form_font,
              }}>
              <PaymentForm>
                <FormLeft>
                  <MerchantImage>
                    <img src={ctrl.props.payment_logo || imgSrc} alt="stripe_merchant_image" />
                  </MerchantImage>
                  <PaymentInfo>
                    {!ctrl.props.list_products && (
                      <div>
                        <h4 id="item">{lineItem.name}</h4>
                        <h3>Total Amount</h3>
                        <h2>
                          {lineItem.currency} {lineItem.amount / ctrl.props.sub_unit}
                        </h2>
                      </div>
                    )}

                    {ctrl.props.list_products && (
                      <div>
                        <h4 id="item">{selectedSubscriptionProductDetails?.nickname}</h4>
                        <h3>Subscription details</h3>
                        <h2>
                          {ctrl.props.currency} {selectedSubscriptionProductDetails?.amount / ctrl.props.sub_unit}
                        </h2>
                        {selectedSubscriptionProductDetails?.trial_period_days && (
                          <p>Trialing for {selectedSubscriptionProductDetails?.trial_period_days} days.</p>
                        )}
                      </div>
                    )}
                  </PaymentInfo>
                </FormLeft>

                <FormRight>
                  <form id={`{stripe_paymentform-${ctrl.internal_id}}`}>
                    <CardElementWrapper>
                      <h3>Enter your card details</h3>
                      <div id={`{stripe_card_element-${ctrl.internal_id}}`}>
                        {/* Stripe Element below */}
                        <CardElement options={options} onChange={handleCardElement} />
                      </div>
                      {/* Used to display card info errors */}
                      <span id={`{stripe_card_error-${ctrl.internal_id}}`} />
                    </CardElementWrapper>

                    <div>
                      <Field>
                        <label htmlFor={`stripe-${ctrl.internal_id}-name`}>Name on card</label>
                        <Input
                          type="text"
                          name="name"
                          id={`stripe-${ctrl.internal_id}-name`}
                          placeholder="Jane Doe"
                          required
                          autoComplete="name"
                          disabled={disableInputs}
                          value={formData.name}
                          onChange={handleInputChange}
                        />
                      </Field>

                      <Field>
                        <label htmlFor={`stripe-${ctrl.internal_id}-email`}>Email</label>
                        <Input
                          type="email"
                          name="email"
                          id={`stripe-${ctrl.internal_id}-email`}
                          placeholder="janedoe@gmail.com"
                          required
                          autoComplete="email"
                          disabled={disableInputs}
                          value={formData.email}
                          onChange={handleInputChange}
                        />
                      </Field>

                      {ctrl.props.billing_address && (
                        <div style={{ marginTop: '25px' }}>
                          <h3>Shipping &amp; Billing Information</h3>
                          <Field>
                            <label htmlFor={`stripe-${ctrl.internal_id}-address1`}>Address line 1</label>
                            <Input
                              type="text"
                              name="line1"
                              id={`stripe-${ctrl.internal_id}-address1`}
                              placeholder="shipping Address"
                              required
                              autoComplete="address"
                              disabled={disableInputs}
                              value={formData.line1}
                              onChange={handleInputChange}
                            />
                          </Field>
                          <Fields>
                            <Field>
                              <label htmlFor={`stripe-${ctrl.internal_id}-city`}>City</label>
                              <Input
                                type="text"
                                name="city"
                                id={`stripe-${ctrl.internal_id}-city`}
                                placeholder="City"
                                required
                                disabled={disableInputs}
                                value={formData.city}
                                onChange={handleInputChange}
                              />
                            </Field>
                            <Field>
                              <label htmlFor={`stripe-${ctrl.internal_id}-state`}>State</label>
                              <Input
                                type="text"
                                name="state"
                                id={`stripe-${ctrl.internal_id}-state`}
                                placeholder="State"
                                required
                                disabled={disableInputs}
                                value={formData.state}
                                onChange={handleInputChange}
                              />
                            </Field>
                          </Fields>
                          <Fields>
                            <Field>
                              <label htmlFor={`stripe-${ctrl.internal_id}-postal_code`}>ZIP/Postal Code</label>
                              <Input
                                type="text"
                                name="postal_code"
                                id={`stripe-${ctrl.internal_id}-postal_code`}
                                placeholder="Zip/Postal code"
                                required
                                disabled={disableInputs}
                                value={formData.postal_code}
                                onChange={handleInputChange}
                              />
                            </Field>
                            <Field>
                              <label htmlFor={`stripe-${ctrl.internal_id}-country`}>Country</label>
                              <select
                                name="country"
                                id={`stripe-${ctrl.internal_id}-country`}
                                className="ui fluid dropdown"
                                disabled={disableInputs}
                                value={formData.country}
                                onChange={handleInputChange}>
                                <option value="">&nbsp;</option>
                                {getCountriesList().map((c) => (
                                  <option value={c.code} key={c.name}>
                                    {c.name}
                                  </option>
                                ))}
                              </select>
                            </Field>
                          </Fields>
                        </div>
                      )}

                      {ctrl.props.save_card_stripe && (
                        <Field className="ui checkbox" style={{ marginTop: '20px' }}>
                          <input
                            type="checkbox"
                            id={`saveCardStripe-${ctrl.internal_id}`}
                            checked={storeCardInfo}
                            onChange={handleCheckSaveCard}
                            disabled={disableInputs}
                          />
                          <label className="checkbox" htmlFor={`saveCardStripe-${ctrl.internal_id}`}>
                            Save my card details to the merchant&apos;s Stripe account
                          </label>
                        </Field>
                      )}

                      <SubmitButton>
                        <button
                          type="submit"
                          onClick={handleFormSubmit}
                          disabled={finalAmount <= 0 || !stripe || !elements || disableInputs}>
                          {renderButtonText()}
                        </button>
                      </SubmitButton>
                    </div>
                  </form>
                </FormRight>
              </PaymentForm>

              {isPaying && !isError && (
                <Dimmer active>
                  <Loader size="massive">Processing payment...</Loader>
                </Dimmer>
              )}
            </PaymentFormWrapper>
          </Modal.Content>
        </Modal>
      </Transition>
    </>
  );
};

export default StripeCheckoutForm;

StripeCheckoutForm.defaultProps = {
  formDesign: null,
  selectedSubscriptionProductDetails: {},
  finalAmount: 0,
  isError: false,
};

StripeCheckoutForm.propTypes = {
  ctrl: PropTypes.shape(ControlPropType).isRequired,
  finalAmount: PropTypes.number,
  isPaying: PropTypes.bool.isRequired,
  isError: PropTypes.bool,
  disableInputs: PropTypes.bool.isRequired,
  storeCardInfo: PropTypes.bool.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleFormSubmit: PropTypes.func.isRequired,
  handleCheckSaveCard: PropTypes.func.isRequired,
  handleCardElement: PropTypes.func.isRequired,
  updateState: PropTypes.func.isRequired,
  showCheckoutForm: PropTypes.bool.isRequired,
  formData: PropTypes.shape({
    postal_code: PropTypes.string,
    name: PropTypes.string,
    email: PropTypes.string,
    line1: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    country: PropTypes.string,
  }).isRequired,
  lineItem: PropTypes.shape({
    amount: PropTypes.number,
    currency: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
  selectedSubscriptionProductDetails: PropTypes.shape({
    plan: PropTypes.string,
    nickname: PropTypes.string,
    amount: PropTypes.number,
    trial_period_days: PropTypes.number,
    one_time: PropTypes.bool,
  }),
  formDesign: PropTypes.shape({
    old: PropTypes.object.isRequired,
    design: PropTypes.object.isRequired,
  }),
};
